import { i18n } from "@/plugins/i18n";
import { config } from "/app.config";

export default [
      {
        path: "finance",
        name: "account.finance",
        component: () => import("@/views/Finance/Finance"),
        redirect: { name: "account.finance.analytics" },
        meta: {
          pageTitle: config.isSurferNetwork ? "Revenue" : "Finance",
          rule: "owner",
        },
        children: [
          {
            path: "analytics",
            component: () => import("@/views/Finance/FinanceAnalytics"),
            name: "account.finance.analytics",
            meta: {
              pageTitle: config.isSurferNetwork
                ? "Revenue analytics"
                : i18n.t("route.page_title.account.finance.analytics"),
              parent: "account.finance",
              rule: "owner",
            },
          },
        ],
      },
    ];
